<template>
    <div class="content-container">
        <div class="content">
            <div class="container">
                <div class="row">

                    <!-- Title -->
                    <div class="col-12">
                        <div class="title">
                            <h1>{{ pageTitle }}</h1>
                        </div>
                    </div>

                    <!-- Search -->
                    <div class="col-12">
                        <div class="form-group">
                            <label v-if="!bookingPostcode && !error">Postcode <span class="text-danger">*</span></label>
                            <label v-if="bookingPostcode">Great news! Our services are available to <span v-if="!isBookingInStore">you</span><span v-if="isBookingInStore">the customer</span></label>
                            <label v-if="error" class="text-danger">{{ error }}</label>
                            <div class="loading-input-container">
                                <div class="loading-message" v-if="checkingPostcode">We're just checking that postcode</div>
                                <input
                                        class="form-control postcode-search"
                                        :class="{'is-loading': checkingPostcode, 'is-valid': bookingPostcode, 'is-invalid': error}"
                                        :disabled="checkingPostcode"
                                        placeholder="E.g PO1 2AB"
                                        :readonly="bookingPostcode"
                                        type="text"
                                        v-model="postcode"
                                        v-on:keyup="postcodeWatcher"
                                />
                            </div>
                            <template v-if="!postcodeEmpty && !error">
                                <small v-if="!bookingPostcode && !checkingPostcode" class="form-text text-muted">This is so we can check what services are available to <span v-if="!isBookingInStore">you</span><span v-if="isBookingInStore">the customer</span></small>
                                <small v-if="bookingPostcode" @click="clearPostcode()" class="cursor-pointer form-text text-underline">Change postcode</small>
                            </template>
                            <div v-if="error && carrier === 'samsungrepair'" class="mt-2">
                                <a href="https://www.samsung.com/uk/support/repair" class="text-underline text-danger">Click here for other repair options.</a>
                            </div>

                            <small v-if="postcodeEmpty" class="form-text text-danger">Please enter a postcode</small>
                        </div>
                    </div>

                </div>
            </div>
            <!-- Footer -->
            <footer class="footer fixed-footer">
                <div class="container">

                    <button class="btn btn-primary btn-lg continue-btn icon-right ml-auto" @click="checkPostcode" v-if="!bookingPostcode" :class="{'disabled': checkingPostcode || !postcode}">Check <span class="d-none d-sm-inline">postcode</span> <i class="fa fa-chevron-right ml-3 text-sm"></i></button>


                    <button @click="nextStep()" class="btn btn-primary btn-lg continue-btn icon-right ml-auto" v-if="bookingPostcode">Next <i class="fa fa-chevron-right ml-3 text-sm"></i></button><!-- TODO: This will need go elsewhere if selecting doorstep repair from in-store -->
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: 'PostcodeSearch',

        data() {
            return {
                checkingPostcode: false,
                postcode: null,
                postcodeEmpty: false,
                error: null
            }
        },

        mounted() {
            this.checkBookingIsComplete();
            
            if (this.bookingPostcode) {
                this.postcode = this.bookingPostcode;
            }
        },

        computed: {
            ...mapGetters(['bookingPostcode', 'carrier', 'carrierDetails', 'isBookingInStore', 'onlyOfferSamsung', 'requiresStore', 'store']),

            pageTitle() {
                if (this.isBookingInStore) {
                    return "What is the customer's postcode?";
                }

                return "What is your postcode?";
            }
        },

        methods: {
            ...mapActions(['checkBookingIsComplete', 'clearBookingPostcode', 'loadTypes', 'selectMake', 'setBookingPostcode']),

            checkPostcode() {

                this.postcodeEmpty = false;
                this.error = null;

                if (!this.postcode) return this.postcodeEmpty = true;

                let postcode = this.postcode.replace(/\s/g, '');

                if (!postcode) return this.postcodeEmpty = true;
                this.checkingPostcode = true;
                this.setBookingPostcode(postcode)
                    .then(() => {
                        this.checkingPostcode = false;
                        this.nextStep();
                    })
                    .catch(error => {
                        this.checkingPostcode = false;

                        if (this.carrierDetails.additionalLandingPage) {
                            this.$router.push({name: 'repairOptionsExternal'});

                        } else {
                            this.error = error.response.data.messages[0];
                            this.$bvModal.show("error-modal")
                        }
                    });
            },

            clearPostcode() {
                this.postcode = null;
                this.clearBookingPostcode();
            },

            nextStep() {
                if (this.onlyOfferSamsung) {
                    this.selectMake({
                        id: 2
                    }).then(() => {
                        this.loadTypes();
                        this.$router.push({name: 'deviceType'});
                    })
                    return
                }

                return this.$router.push({name: 'deviceMake'});
            },

            postcodeWatcher(event) {
                if(event.key === "Enter") {
                    this.checkPostcode();
                }
            },
        }
    }
</script>

<style scoped>

</style>